import { Trash2, Edit2, Paperclip, StopCircle, CircleCheck, ShieldCheck, TriangleAlert, Plus, Edit, Move, Folder, Target, CheckCircle2, Activity, Undo2 } from "lucide-react";
import React from "react";
import { ETaskActions } from "types";

export const iconsPopup = {
    'warn': <TriangleAlert color="orange" />,
    'delete': <Trash2 color="red" />,
}

export const taskActions = [
    {
        action: ETaskActions.EDIT,
        name: 'Sửa',
        icon: <Edit2 color={'green'} size={16} />,
    },
    {
        action: ETaskActions.ATTACHMENT,
        name: 'Đính kèm file',
        icon: <Paperclip color={'orange'} size={16} />,
    },
    {
        action: ETaskActions.CLOSED,
        name: 'Đóng',
        icon: <StopCircle color={'blue'} size={16} />,
    },
    {
        action: ETaskActions.OPEN,
        name: 'Mở',
        icon: <Undo2 color={'blue'} size={16} />,
    },
    {
        action: ETaskActions.DELETE,
        name: 'Xoá',
        icon: <Trash2 color={'red'} size={16} />,
    }
];

export const taskBoardActions = [
    {
        action: ETaskActions.EDIT,
        name: 'Sửa',
        icon: <Edit2 size={16} />,
    },
    {
        action: ETaskActions.DELETE,
        name: 'Xoá',
        icon: <Trash2 size={16} />,
    }
];

export const projectActions = [
    {
        action: 'edit',
        name: 'Sửa',
        icon: <Edit2 size={16} className="mr-2" />,
    },
    {
        action: 'completed',
        name: 'Xong',
        icon: <CircleCheck size={16} className="mr-2" />,
    },
    {
        action: 'pending',
        name: 'Dừng',
        icon: <StopCircle size={16} className="mr-2" />,
        other: {
            action: 'in_progress',
            name: 'Open',
            icon: <ShieldCheck size={16} className="mr-2" />,
        },
    },
    {
        action: 'delete',
        name: 'Xoá',
        icon: <Trash2 size={16} className="mr-2" />,
    }
];

export const getActionIcon = (action, targetType) => {
    const iconMap = {
        created: <Plus className="w-4 h-4 text-green-600" />,
        updated: <Edit className="w-4 h-4 text-blue-600" />,
        deleted: <Trash2 className="w-4 h-4 text-red-600" />,
        moved: <Move className="w-4 h-4 text-purple-600" />
    };

    const typeIconMap = {
        board: <Folder className="w-4 h-4 text-orange-600" />,
        project: <Target className="w-4 h-4 text-indigo-600" />,
        task: <CheckCircle2 className="w-4 h-4 text-teal-600" />
    };

    return iconMap[action] || typeIconMap[targetType.toLowerCase()] || <Activity className="w-4 h-4 text-gray-500" />;
};

export const getMentionText = (text, users) => {
    const mentionRegex = /@(\w+)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = mentionRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.substring(lastIndex, match.index));
        }
        const mentionText = match[1];
        // const mentionText = match[0];
        const isValidMention = users.some(user =>
            mentionText === `${user.email.split('@')[0]}`// || mentionText.includes(user.name)
        );

        parts.push(
            <span key={match.index} className={`${isValidMention ? 'text-blue-600 bg-blue-300' : 'text-blue-300'}'`}>
                @{mentionText}
            </span>
        );

        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
    }

    return parts;
};


